import React from 'react';
import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';

export const NotFound: React.FC = () => (
  <div className="flex flex-col items-center justify-center py-24 text-center px-4">
    <SearchX className="w-12 h-12 text-neutral-400 mb-4" />
    <h2 className="text-xl font-semibold text-neutral-900 mb-2">Page not found</h2>
    <p className="text-neutral-600 mb-6">This page doesn't exist or hasn't been built yet.</p>
    <Link
      to="/"
      className="flex items-center gap-1.5 px-4 py-2 bg-rugby-primary-600 text-white text-sm font-medium rounded-lg hover:bg-rugby-primary-700 transition-colors"
    >
      Back to dashboard
    </Link>
  </div>
);
